export const isEmpty = (text: string) => {
  return text === '';
};

export const replaceNewLineCharacter = (text: string) => {
  return text.replace('\\n', '\n');
};
